// extracted by mini-css-extract-plugin
module.exports = {"plotPath":"t1pHPGVA"};